document.addEventListener("DOMContentLoaded", function() {
    const articleContent = document.querySelector(".article-template__content");
    if (!articleContent) return;

    const firstParagraph = articleContent.querySelector("p");
    const headers = articleContent.querySelectorAll("h2, h3");
    const tocContainer = document.createElement("div"); // Tworzymy spis treści jako nowy element
    tocContainer.id = "toc-container";

    if (headers.length > 0) {
        // Dodaj nagłówek "W artykule:" przed spisem treści
        const tocHeading = document.createElement("h3");
        tocHeading.textContent = "W artykule:";
        tocContainer.appendChild(tocHeading);

        const tocList = document.createElement("ul");
        let h2Count = 0;
        let h3Count = 0;
        let currentH2Item = null;

        headers.forEach((header, index) => {
            const tagName = header.tagName.toLowerCase();
            const id = `section${index + 1}`;
            header.setAttribute("id", id);

            if (tagName === "h2") {
                h2Count++;
                h3Count = 0;

                const listItem = document.createElement("li");
                const link = document.createElement("a");
                link.setAttribute("href", `#${id}`);
                link.textContent = `${h2Count}. ${header.textContent}`;

                link.addEventListener("click", function(event) {
                    event.preventDefault();

                    // Usuń poprzednie efekty
                    headers.forEach(h => {
                        h.style.transition = "";
                        h.style.transform = "";
                    });

                    // Płynne przewinięcie do nagłówka
                    document.querySelector(`#${id}`).scrollIntoView({
                        behavior: 'smooth'
                    });

                    // Opóźnienie, zanim pojawi się efekt "jojo"
                    setTimeout(() => {
                        header.style.transition = "transform 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55)"; // Efekt odbicia
                        header.style.transform = "translateX(20px)"; // Przesunięcie o 20px w prawo
                    }, 500);

                    // Powrót na swoje miejsce z lekkim opóźnieniem
                    setTimeout(() => {
                        header.style.transform = "translateX(0)";
                    }, 1000);
                });

                listItem.appendChild(link);
                tocList.appendChild(listItem);

                currentH2Item = listItem;
            } 
            else if (tagName === "h3" && currentH2Item) {
                h3Count++;

                let subList = currentH2Item.querySelector("ul");
                if (!subList) {
                    subList = document.createElement("ul");
                    currentH2Item.appendChild(subList);
                }

                const listItem = document.createElement("li");
                const link = document.createElement("a");
                link.setAttribute("href", `#${id}`);
                link.textContent = `${h2Count}.${h3Count} ${header.textContent}`;

                link.addEventListener("click", function(event) {
                    event.preventDefault();

                    headers.forEach(h => {
                        h.style.transition = "";
                        h.style.transform = "";
                    });

                    document.querySelector(`#${id}`).scrollIntoView({
                        behavior: 'smooth'
                    });

                    setTimeout(() => {
                        header.style.transition = "transform 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55)"; // Efekt odbicia
                        header.style.transform = "translateX(20px)"; // Przesunięcie o 20px w prawo
                    }, 500);

                    setTimeout(() => {
                        header.style.transform = "translateX(0)";
                    }, 1000);
                });

                listItem.appendChild(link);
                subList.appendChild(listItem);
            }
        });

        tocContainer.appendChild(tocList);

        // Umieść spis treści po pierwszym paragrafie
        if (firstParagraph) {
            firstParagraph.insertAdjacentElement("afterend", tocContainer);
        } else {
            // Jeśli nie ma paragrafu, wstaw na koniec kontenera
            articleContent.appendChild(tocContainer);
        }
    }
});
